/* eslint-disable import/no-cycle */
import axios from 'axios';
import qs from 'qs';

import { store } from '../store/store';
import { router } from './router/router';

// Il backend non risponde: manutenzione Laravel (503) o gateway/container giu'.
const UNAVAILABLE_STATUSES = [502, 503, 504];

const http = axios.create();

http.interceptors.request.use(
  config => {
    config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });
    if (localStorage.getItem('auth-token')) {
      config.headers.common.Authorization = localStorage.getItem('auth-token');
    }
    return config;
  },
  error => Promise.reject(error),
);

http.interceptors.response.use((response) => {
  store.dispatch('system/reportReachable');
  return response;
},
  (error) => {
  const { loggedIn } = store.state.auth;
  const { response } = error;
  if (response && response.status === 401 && loggedIn) {
    localStorage.removeItem('auth-token');
    store.commit('auth/logout');
    window.location = router.resolve({ name: 'login' }).href;
    return Promise.reject(error);
  }

  const data = response && response.data;
  if (response && response.status === 503 && data && data.maintenance) {
    // Payload esplicito della manutenzione: non serve nessuna verifica.
    store.dispatch('system/reportMaintenance');
  } else if (response && UNAVAILABLE_STATUSES.includes(response.status)) {
    store.dispatch('system/check');
  } else if (!response && !axios.isCancel(error)) {
    // Nessuna risposta: backend irraggiungibile, CORS bloccato o rete assente.
    store.dispatch('system/check');
  }

  return Promise.reject(error);
});

export { http as axios };
